import { useEffect } from "react";
import { getAuthData, clearAuthData } from "./authStorage";

/**
 * HOC to protect routes in plain React.
 * Redirects to login page if no token is found.
 * @param {React.Component} Component
 */
export function withAuth(Component) {
  return function ProtectedRoute(props) {
    useEffect(() => {
      const authData = getAuthData();
      const token = authData?.token;

      if (!token) {
        // Clear any stale auth data
        clearAuthData();

        // Redirect to login (browser redirect)
        window.location.href = "/login"; // or your custom login route
      }
    }, []);

    return <Component {...props} />;
  };
}
